import { render, staticRenderFns } from "./SourceFormModal.vue?vue&type=template&id=2498f67b&"
import script from "./SourceFormModal.vue?vue&type=script&lang=js&"
export * from "./SourceFormModal.vue?vue&type=script&lang=js&"
import style0 from "./SourceFormModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports